module.exports = __webpack_public_path__ + "img/feature.803c3bf4.svg";